import { Lock, ShieldCheck, EyeOff, Brain } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const TrustSection = () => {
  const { t } = useI18n();
  
  const trustItems = [
    {
      icon: Lock,
      label: t('trust.encryption.label'),
      tooltip: t('trust.encryption.tooltip'),
    },
    {
      icon: ShieldCheck,
      label: t('trust.compliance.label'),
      tooltip: t('trust.compliance.tooltip'),
    },
    {
      icon: EyeOff,
      label: t('trust.no_sharing.label'),
      tooltip: t('trust.no_sharing.tooltip'),
    },
    {
      icon: Brain,
      label: t('trust.ai_reviewed.label'),
      tooltip: t('trust.ai_reviewed.tooltip'),
    },
  ];

  return (
    <section className="w-full bg-muted/30 py-12 px-4 animate-fade-in mb-32">
      <div className="max-w-[500px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-semibold text-foreground mb-2">
            {t('trust.title')}
          </h2>
          <p className="text-sm text-muted-foreground">
            {t('trust.subtitle')}
          </p>
        </div>

        <TooltipProvider>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4">
            {trustItems.map((item, index) => {
              const Icon = item.icon;
              return (
                <Tooltip key={index}>
                  <TooltipTrigger asChild>
                    <div className="flex flex-col items-center text-center cursor-help group transition-all duration-300 hover:-translate-y-1">
                      <div className="w-14 h-14 rounded-full bg-background border border-border flex items-center justify-center mb-3 group-hover:border-[#C5A25D] transition-colors">
                        <Icon 
                          className="w-6 h-6 text-[#C5A25D]" 
                          strokeWidth={1.5}
                        />
                      </div>
                      <p className="text-xs font-medium text-foreground leading-tight">
                        {item.label}
                      </p>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent 
                    side="top" 
                    className="max-w-[200px] text-center"
                  >
                    <p className="text-xs">{item.tooltip}</p>
                  </TooltipContent>
                </Tooltip>
              );
            })}
          </div>
        </TooltipProvider>
      </div>
    </section>
  );
};

export default TrustSection;
